// all available languages
const langs = ['pl','en'];

// set default language
const defaultLocale = 'pl';

// get language from url
const urlLocale = window.location.pathname.replace(process.env.BASE_URL,'/').replace(/^\/([^\/]+).*/i,'$1');

// if url has no known language then set default language
const locale = langs.includes(urlLocale) ? urlLocale : defaultLocale;

// export
export { langs, defaultLocale, locale };
